import { render } from "./TheScootersDetails.vue?vue&type=template&id=273169c6"
import script from "./TheScootersDetails.vue?vue&type=script&lang=js"
export * from "./TheScootersDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__